import { gridMap } from '../mapgrid.ts';
import { withGeometry } from '../mapgeo.ts';
import { MARKET_GEO } from './marketgeo.ts';

/**
 * Night Market: a rain-wet old quarter in the dark, built at every scale. West half (the east is its half turn, dressed as other
 * districts by the theme): the walled Temple Court in the north-west corner with its great hall; Festival Square (zone A) beside
 * it; Lantern Alley, a warren of small shops and narrow lanes under tarps; the Night Bazaar hall; the Old Canal with three bridges;
 * the covered produce market by the red spawn; the open Neon Crossing (zone B); a multi-storey car park, the night-bus square and
 * the arcade hall in the south-west; Noodle Lane's warren in the south.
 * T stall counter, H shopfront (a run one cell thin is a hall's or compound's wall), K crate stack, V scooter.
 * The canal, roofs, doors, carts, shrine posts and the car park's pillars are in marketgeo.ts.
 */
const MARKET_GRID = gridMap('Night Market', `
  ...............................K............K...............
  ...............................K............K...............
  .....................HHHH..HHH..........HHH..HHHHHHH........
  .....................HHHH..HHH..HHHHHH..HHH..HHHHHHH..HHHHH.
  .....HHHHHHHHHHHH....HHHH..HHH..HHHHHH..HHH..HHHHHHH..HHHHH.
  .....HK..TTTT..KH....HHHH..HHH..HHHHHH.......HHHHHHH..HHHHH.
  ...T.H..........H..e.HHHH.......HHHHHH...p............HHHHH.
  ...T.H..........................HHHHHH..HHH.................
  ...T.H..................................HHH..HHHHHH.........
  ...T.H..........H....HHH..HHHHHHH......lHHH..HHHHHH...HHHHH.
  ...T.H..........H....HHH..HHHHHHH..HHH..HHH..HHHHHH...HHHHH.
  .....H..........H....HHH..HHHHHHH..HHH.......HHHHHH...HHHHH.
  .....HHHH....HHHH....HHH..HHHHHHH..HHH................HHHHH.
  ..................m..HHH...........HHH................HHHHH.
  .....................HHH...........HHH..HHHHH..HHHHHH.HHHHH.
  ..H..................HHH..HHHHH....HHH..HHHHH..HHHHHH.......
  ..H.......................HHHHH....HHH..HHHHH..HHHHHH.......
  ..H..K.........K..........HHHHH....HHH..HHHHH...............
  ..H.....................................HHHHH...............
  ..H..................................................b......
  ..H....................................KK...................
  ..H..................................K......................
  ..HHHHHHH....HHHHH......KK..........l................HHHHHH.
  .......................................HHHHHHH...HH..HHHHHH.
  ......................c................H..........H..HHHHHH.
  .......................................H..........H..HHHHHH.
  ..........................................TTTTTT..H..HHHHHH.
  ...................................c..............H.........
  ......FFF...................A.....................H.........
  ......FFF..............................H..TTTTTT..H.........
  ......FFF...HHHHHH.....................H..........H..HHH....
  ............HHHHHH.....................H..........H..HHH...K
  ............HHHHHH.....................HHHH....HHHH..HHH....
  ............HHHHHH...................................HHH....
  ............HHHHHH...............K...................HHH....
  .......................l.........K...................HHH....
  .......................................HHHHH................
  .......................................HHHHH................
  ............................................................
  ............................................................
  ......................................................FFF...
  ......................................................FFF...
  ......................................................FFF...
  ............................................................
  .........................b..................................
  ..............c.....................HHHHHHHHH...............
  ....................................HHHHHHHHH...............
  ...HHHHHHHHH........HHHHHHHHH..HH...HHHHHHHHH...HHH.........
  ...HHHHHHHHH........HHHHHHHHH..HH...HHHHHHHHH...HHH.........
  ...HHHHHHHHH........HHHHHHHHH.......HHHHHHHHH...HHH.........
  ...HHHHHHHHH........HHHHHHHHH.......HHHHHHHHH.........l.....
  ...HHHHHHHHH........HHHHHHHHH.......HHHHHHHHH...............
  ...HHHHHHHHH........HHHHHHHHH.......HHHHHHHHH...............
  ....................HHHHHHHHH....................TTTT.......
  ....................HHHHHHHHH...............................
  .....TTTT......................................c............
  ....................................................V.......
  ........RRRRRRRR.................cHH................V.......
  ........RRRRRRRR..K...............HH........................
  ........RRRRRRRR..K...............HH..........FFF...........
  ........RRRRRRRR..................HH..........FFF...........
  ........RRRRRRRR..................HH..........FFF...........
  ........RRRRRRRR..................HH........................
  ..............................c.............................
  ..................................a.........................
  ..........TTTT.......TTTT..TTTT................c.....KK.....
  .................l..................HHHHHHHH................
  ....................................HHHHHHHH................
  ....HHHHH............TTTT..TTTT.....HHHHHHHH................
  ....HHHHH...........................HHHHHHHH................
  ....HHHHH..HHHH.....................HHHHHHHH....HHH...l.....
  ....HHHHH..HHHH......TTTT..TTTT.....HHHHHHHH....HHH.........
  ...........HHHH.................................HHH.........
  ...........HHHH.............................................
  ...........HHHH........................HHHHH................
  .......................................HHHHH................
  ..................FFF.......................................
  ...........l......FFF....HHHHHHHH............c..............
  ..................FFF....HHHHHHHH................HHH........
  .........................HHHHHHHH...HHHHHHHHHH...HHH........
  .....HHHHH.....HHHHHH....HHHHHHHH...HHHHHHHHHH...HHH........
  .....H..............H....HHHHHHHH...HHHHHHHHHH...HHH........
  .....H..............H...............HHHHHHHHHH...HHH........
  .....H..............H...............HHHHHHHHHH..............
  .....H.................b....................................
  .....H......................................................
  .....H.....VV...............................................
  .....H....................TTTT..............................
  .....H.............................c.......................K
  .....H..............H..................HH......l............
  .....H.....VV.......H..................HH...................
  .....H..............H.......................................
  .....H..............H..........FFF..........................
  .....HHHHHHH....HHHHH..........FFF..........................
  ...............................FFF.................FFF......
  ......................o............................FFF......
  ...................................................FFF......
  .........................m..................................
  ...HHHHHHHH...HHHHHH..........................HHH...........
  ...HHHHHHHH...HHHHHH....................HHHH..HHH..HHHHHHHH.
  ...HHHHHHHH...HHHHHH....................HHHH..HHH..HHHHHHHH.
  ...HHHHHHHH...HHHHHH....................HHHH..HHH..HHHHHHHH.
  ...HHHHHHHH.............................HHHH..HHH...........
  ...HHHHHHHH............HHHH....HHHHH....HHHH................
  .......................H...........H.................c......
  .......................H.........K.H........l.........HHHHH.
  ......i............c...H..K...K..K......HHH..HHHHHHH..HHHHH.
  ............HHHHHHH....H..K...K.........HHH..HHHHHHH..HHHHH.
  ...HHHHHH...HHHHHHH.......K...K.........HHH..HHHHHHH..HHHHH.
  ...HHHHHH...HHHHHHH.......K...K....H..g.HHH...........HHHHH.
  ...HHHHHH...HHHHHHH....H...........H....HHH...........HHHHH.
  ...HHHHHH...HHHHHHH....H...........H....HHH..HHHHH..........
  ...HHHHHH..............HHHHHHHHHHHHH....HHH..HHHHH..........
  ...HHHHHH....................................HHHHH..HHHHHHH.
  ...HHHHHH....................................HHHHH..HHHHHHH.
  ...HHHHHH.....HH.............................HHHHH..HHHHHHH.
  ...HHHHHH.FFF.HH.......................HHH...HHHHH..........
  ..........FFF..........................HHH..................
  ..........FFF...............................................
  ............................................................
`, 'market');

export const MARKET = withGeometry(MARKET_GRID, MARKET_GEO);
